import React from "react";
import { Icon, CheckCircle, Passengers } from "./icons";
import { Photo } from "./photo";

const HERO_CHIPS = [
  { icon: "shield", line1: "Sécurité", line2: "avant tout" },
  { icon: "clock", line1: "Ponctualité", line2: "garantie" },
  { icon: "discretion", line1: "Bienveillance", line2: "& discrétion" },
  { icon: "service", line1: "Communication", line2: "avec les parents" },
];

const FAMILY_POINTS = [
  "Domicile → école",
  "École → domicile",
  "Aller-retour quotidien",
  "Transport vers plusieurs établissements selon vos besoins",
  "Organisation régulière à la semaine",
  "Véhicule privatisé jusqu'à 7 passagers",
  "Ponctualité et suivi des horaires",
  "Communication avec les parents",
];

const SCHOOL_POINTS_A = ["Matin", "Après-midi", "Aller-retour", "Activités extrascolaires"];
const SCHOOL_POINTS_B = [
  "Sorties scolaires et événements",
  "Trajets exceptionnels",
  "Transport de petits groupes",
];

const VEHICLE_POINTS = [
  "Véhicule spacieux",
  "Sièges confortables",
  "Climatisation",
  "Espace pour cartables et bagages",
  "Véhicule entretenu et propre",
  "Transport privatisé",
];

const TRANSFER_POINTS = [
  "Home ↔ School",
  "School ↔ Activities",
  "Daily transfers",
  "Private group transportation",
];

const FORFAIT_ITEMS = [
  { icon: "calendar", title: "1 trajet/jour", text: "ou 2 trajets/jour" },
  { icon: "calendar", title: "5 jours/semaine", text: "ou selon vos besoins" },
  { icon: "family", title: "Plusieurs enfants", text: "Tarif dégressif" },
  { icon: "family", title: "Plusieurs familles", text: "Sur un même secteur" },
];

const ADVANTAGES = [
  { icon: "shield", title: "Sécurité maximale" },
  { icon: "clock", title: "Ponctualité garantie" },
  { icon: "driver", title: "Chauffeure expérimentée" },
  { icon: "discretion", title: "Bienveillance et discrétion" },
  { icon: "pin", title: "Suivi des trajets" },
  { icon: "check", title: "Disponibilité et réactivité" },
];

export const RamassageScolaire = ({ brand, vehicle }) => (
  <>
    <header className="school-hero">
      <div className="container school-hero-inner">
        <div className="school-hero-copy">
          <p className="hero-eyebrow">Écoles privées &amp; familles expatriées</p>
          <h1 className="hero-title">
            Ramassage scolaire
            <br />
            <span className="accent">privé</span>
          </h1>
          <p className="hero-text">
            Un transport scolaire fiable, ponctuel et personnalisé pour accompagner
            <br />
            vos enfants en toute sérénité.
          </p>

          <div className="hero-actions">
            <a href="/#contact" className="btn btn-primary">
              Demander un devis
            </a>
            <a href={`tel:${brand?.phoneLink || ""}`} className="btn btn-dark">
              Appeler
            </a>
          </div>

          <div className="school-hero-chips">
            {HERO_CHIPS.map((c) => (
              <div className="hero-chip" key={c.line1}>
                <Icon name={c.icon} size={20} />
                <span>
                  {c.line1}
                  <br />
                  {c.line2}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="school-hero-media">
          <Photo
            src={vehicle?.image}
            alt="Renault Trafic SAFE MOUV, ramassage scolaire"
            label="Photo véhicule"
            className="school-hero-photo"
          />
          <span className="school-hero-badge">
            <Passengers size={20} />
            Jusqu'à 7 passagers
            <br />
            véhicule privatisé
          </span>
        </div>
      </div>
    </header>

    <section className="section school-split">
      <div className="container school-split-grid">
        <article className="school-card">
          <h2>Pour les familles expatriées</h2>
          <p>
            Vous êtes une famille internationale installée en Île-de-France ? SAFE MOUV
            facilite les trajets quotidiens de vos enfants.
          </p>
          <ul className="school-check-list">
            {FAMILY_POINTS.map((p) => (
              <li key={p}>
                <CheckCircle size={17} />
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <p className="school-card-note">
            Une solution idéale pour les familles qui souhaitent confier les trajets
            scolaires à une chauffeure professionnelle.
          </p>
        </article>

        <article className="school-card school-card-dark">
          <h2>Pour les écoles privées</h2>
          <p>
            SAFE MOUV accompagne les établissements qui souhaitent proposer ou
            externaliser une solution de transport pour leurs élèves.
          </p>

          <p className="school-card-subhead">Ramassage scolaire personnalisé</p>
          <p className="school-card-route">Domiciles → Établissement → Domiciles</p>

          <div className="school-check-cols">
            <ul className="school-check-list">
              {SCHOOL_POINTS_A.map((p) => (
                <li key={p}>
                  <CheckCircle size={17} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
            <ul className="school-check-list">
              {SCHOOL_POINTS_B.map((p) => (
                <li key={p}>
                  <CheckCircle size={17} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <p className="school-card-note">
            Offre sur contrat – Facturation mensuelle
            <br />
            Planning défini à l'avance – Interlocuteur unique
          </p>
        </article>
      </div>
    </section>

    <section className="section school-vehicle">
      <div className="container school-vehicle-grid">
        <div>
          <h2 className="school-eyebrow">Un véhicule adapté</h2>
          <p className="school-vehicle-title">
            {vehicle?.title} – Jusqu'à 7 passagers
          </p>
          <ul className="school-check-list">
            {VEHICLE_POINTS.map((p) => (
              <li key={p}>
                <CheckCircle size={17} />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="school-vehicle-gallery">
          {[vehicle?.image, ...(vehicle?.gallery || [])].slice(0, 3).map((src, i) => (
            <Photo key={src || i} src={src} alt="Intérieur Renault Trafic" label="Photo" />
          ))}
        </div>
      </div>
    </section>

    <section className="section school-transfer">
      <div className="container school-transfer-card">
        <Photo
          src={undefined}
          alt="Famille internationale devant la Tour Eiffel"
          label="Famille expatriée"
          className="school-transfer-photo"
        />
        <div className="school-transfer-text">
          <h2>
            Spécial familles internationales
            <br />
            <span className="accent">School Transfer Service</span>
          </h2>
          <p>Private school transportation for international families</p>
          <ul className="school-check-list">
            {TRANSFER_POINTS.map((p) => (
              <li key={p}>
                <CheckCircle size={17} />
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <p className="school-card-note">
            Un interlocuteur unique pour organiser les déplacements de vos enfants.
          </p>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <h2 className="section-title">Forfait scolaire personnalisé</h2>

        <div className="school-forfait-grid">
          {FORFAIT_ITEMS.map((f) => (
            <div className="school-forfait-item" key={f.title}>
              <span className="tarif-icon">
                <Icon name={f.icon} size={26} />
              </span>
              <div>
                <strong>{f.title}</strong>
                <p>{f.text}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="section-lead" style={{ marginTop: 28 }}>
          Devis personnalisé selon la distance, le temps et l'organisation du circuit.
        </p>
      </div>
    </section>

    <section className="school-advantages">
      <div className="container school-advantages-inner">
        {ADVANTAGES.map((a) => (
          <div className="school-advantage" key={a.title}>
            <Icon name={a.icon} size={22} />
            <span>{a.title}</span>
          </div>
        ))}
      </div>
    </section>

    <section className="bottom-bar">
      <div className="container bottom-bar-inner school-cta-inner">
        <div className="bottom-item">
          <div>
            <h3>Un transport scolaire fiable et personnalisé</h3>
            <p>Service sur réservation – {brand?.availability}</p>
          </div>
        </div>
        <a href="/#contact" className="btn btn-primary bottom-cta">
          Demander un devis
          <em>Réponse rapide et personnalisée</em>
        </a>
      </div>
    </section>
  </>
);

export default RamassageScolaire;
